/**
 * External dependencies
 */
import inherits from 'inherits';

export default class RetailerRentalPlan {
    
    constructor(cscom) {
        if (!(this instanceof RetailerRentalPlan)) {
            return new RetailerRentalPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/retailer-rental-plans/list', null, data);
    }

}
